module.exports = __webpack_public_path__ + "img/priority-low.b9b826e5.svg";